import gql from 'graphql-tag'

export default gql`query ($active: String, $office_id: String){
  filter_users(active: $active, office_id: $office_id){
    user_id
    full_name
  }
}`